// extracted by mini-css-extract-plugin
module.exports = {"sortableHeaderCell":"sortableHeaderCell__3UFMy","carrotIconWrapper":"carrotIconWrapper__38BXr","up":"up__1HdB2"};